export default __webpack_public_path__ + "static/media/2145.3cec3a77.png";